/* eslint-disable */
import { FormRecordFieldView, FormRecordFieldViewFactory, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormRecordMasterDataFieldComponent } from '../../admin/form/form-record/fields/master-data/form-record-master-data-field.component';
/* eslint-enable */

export class FormRecordMasterDataFieldViewFactory implements FormRecordFieldViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createView(): ComponentRef<FormRecordFieldView> {
    const cmp = this.cfr.resolveComponentFactory(FormRecordMasterDataFieldComponent)
      .create(this.injector);
    return cmp;
  }

}
